/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import CaseStudiesChildFooter from "./CaseStudiesChildFooter";
import ic_shopping_cart_big_circle from "../../assets/images/pictures/icon/ic-outline-shopping_cart_big_circle-64px.svg";
import ic_paper_big_circle from "../../assets/images/pictures/icon/ic_paper_super_big_circle.svg";
import ic_info_big_circle from "../../assets/images/pictures/icon/ic_info_super_big_circle.svg";
import ic_quote_big_circle from "../../assets/images/pictures/icon/ic_quote_super_big_circle.svg";
import ic_order_big_circle from "../../assets/images/pictures/icon/ic_shopping_cart_super_big_circle.svg";
import ic_confirm_big_circle from "../../assets/images/pictures/icon/ic_confirm_super_big_circle.svg";
import { motion } from "framer-motion";
import routeVariants from "../../assets/animates/routeVariants";
import list from "../../assets/images/logos/case/doclist.png";
import cover from "../../assets/images/logos/case/cover-procurement.png";
import telia from "../../assets/images/logos/case/telia.png";
import luminor from "../../assets/images/logos/case/luminor.png";
import { useTranslation } from "react-i18next";
import Footer from "../../components/global/Footer";
import NavbarBottom from "../../components/global/NavbarBottom";

const CaseStudiesProcurementContent = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      variants={routeVariants}
      initial="initial"
      animate="final"
      id="content"
      className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 no-transform"
    >
      <header className="header--absolute"></header>

      <div className="procurement mt-50">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-10 col-sm-offset-1 header">
              <img
                className="header__ic"
                src={ic_shopping_cart_big_circle}
                alt=""
                data-no-retina=""
              />
              <h2 className="font-weight-bold">
                {t(
                  "case-studies-procurement-page.case-studies-procurement-page-content.content-1.heading"
                )}
              </h2>
              <p>
                {t(
                  "case-studies-procurement-page.case-studies-procurement-page-content.content-1.description"
                )}
              </p>
            </div>
            <div className="col-xs-12">
              <img className="img-responsive" src={list} alt="" />
            </div>
          </div>
          <div className="row stages">
            <div className="col-xs-12 col-sm-8 col-sm-offset-2">
              <h2>
                {t(
                  "case-studies-procurement-page.case-studies-procurement-page-content.content-2.heading"
                )}
              </h2>
            </div>
            <div className="col-xs-12 col-sm-8 col-sm-offset-2">
              <p>
                {t(
                  "case-studies-procurement-page.case-studies-procurement-page-content.content-2.description"
                )}
              </p>
            </div>
          </div>

          <div className="row stages-hr">
            <div className="col-md-2 col-md-offset-1 col-sm-4 stages-cycle__container">
              <div className="stages-cycle__item">
                <img src={ic_paper_big_circle} alt="" data-no-retina="" />
                <p>
                  {t(
                    "case-studies-procurement-page.case-studies-procurement-page-content.content-2.step-1"
                  )}
                </p>
                <span>(RFP)</span>
              </div>
            </div>
            <div className="col-md-2 col-sm-4 stages-cycle__container">
              <div className="stages-cycle__item">
                <img src={ic_info_big_circle} alt="" data-no-retina="" />
                <p>
                  {t(
                    "case-studies-procurement-page.case-studies-procurement-page-content.content-2.step-2"
                  )}
                </p>
                <span>(RFI)</span>
              </div>
            </div>
            <div className="col-md-2 col-sm-4 stages-cycle__container">
              <div className="stages-cycle__item">
                <img src={ic_quote_big_circle} alt="" data-no-retina="" />
                <p>
                  {t(
                    "case-studies-procurement-page.case-studies-procurement-page-content.content-2.step-3"
                  )}
                </p>
                <span>(RFQ)</span>
              </div>
            </div>
            <div className="col-md-2 col-sm-4 stages-cycle__container">
              <div className="stages-cycle__item">
                <img src={ic_order_big_circle} alt="" data-no-retina="" />
                <p>
                  {t(
                    "case-studies-procurement-page.case-studies-procurement-page-content.content-2.step-4"
                  )}
                </p>
                <span>(PO)</span>
              </div>
            </div>
            <div className="col-md-2 col-sm-4 stages-cycle__container">
              <div className="stages-cycle__item">
                <img src={ic_confirm_big_circle} alt="" data-no-retina="" />
                <p>
                  {t(
                    "case-studies-procurement-page.case-studies-procurement-page-content.content-2.step-5"
                  )}
                </p>
                <span>(OC)</span>
              </div>
            </div>
          </div>
          <div className="row about-pro">
            <div className="col-sm-5 pl-md-0">
              <img className="img-responsive" src={cover} alt="" />
            </div>
            <div className="col-sm-7">
              <h2>
                {t(
                  "case-studies-procurement-page.case-studies-procurement-page-content.content-3.heading"
                )}
              </h2>
              <p>
                {t(
                  "case-studies-procurement-page.case-studies-procurement-page-content.content-3.description-1"
                )}
              </p>
              <p>
                {t(
                  "case-studies-procurement-page.case-studies-procurement-page-content.content-3.description-2"
                )}
              </p>
              {/* <a
                className="btn-secondary"
                href="javascript:;"
                data-toggle="modal"
                data-target="#download-book"
              >
                {t(
                  "case-studies-procurement-page.case-studies-procurement-page-content.content-3.button-access"
                )}
              </a> */}
              <hr />
              <h6>
                {t(
                  "case-studies-procurement-page.case-studies-procurement-page-content.content-3.description-3"
                )}
              </h6>
              <div className="departments">
                <img
                  className="departments__icon departments__icon--telia"
                  src={telia}
                  alt="Telia"
                />
                <img
                  className="departments__icon"
                  src={luminor}
                  alt="Luminor"
                />
              </div>
            </div>
          </div>
        </div>
        <CaseStudiesChildFooter />
      </div>
      <Footer />
      <NavbarBottom />
    </motion.div>
  );
};

export default CaseStudiesProcurementContent;
